// extracted by mini-css-extract-plugin
module.exports = {"loader":"CardLoader_loader__29ie7","progressLoader":"CardLoader_progressLoader__CzqsB","loaderRow":"CardLoader_loaderRow__14nIW"};